<template>
  <div class="cnotainer">
    <CmrHeader></CmrHeader>
    <router-view></router-view>
    <!-- <transition name="test" mode="out-in">
      <router-view></router-view>
    </transition> -->
    <CmrFooter></CmrFooter>
  </div>
</template>

<script>
import CmrHeader from "./header/index.vue";
import CmrFooter from "./footer/index.vue";
export default {
  name: "layout",
  components: {
    CmrHeader,
    CmrFooter,
  },
};
</script>

<style scoped lang="less">
.container {
  box-sizing: border-box;
}
.test-enter-from {
  opacity: 0;
}
.test-enter-to {
  opacity: 1;
}
.test-enter-active {
  transition: all 0.75s ease-out;
}
.test-leave-from {
  opacity: 1;
}
.test-leave-to {
  opacity: 0;
}
.test-leave-active {
  transition: all 0.75s ease-out;
}
</style>